/**
 * Softly Softly — Date formatting utilities
 * European format: dd/mm/yyyy
 * All calendars start on Monday
 */

export function formatDate(date) {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d)) return ''
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}

export function formatDateShort(date, alwaysShowYear = false) {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d)) return ''
  const day = d.getDate()
  const month = d.toLocaleString('en-GB', { month: 'long' })
  const year = d.getFullYear()
  const currentYear = new Date().getFullYear()
  if (alwaysShowYear || year !== currentYear) return `${day} ${month} ${year}`
  return `${day} ${month}`
}

export function formatDateRelative(date) {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d)) return ''
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  if (d.toDateString() === today.toDateString()) return 'Today'
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'
  return formatDate(d)
}

export function formatDateTime(date) {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d)) return ''
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
  return `${formatDate(d)} at ${time}`
}

export function formatMonthYear(date) {
  if (!date) return ''
  const d = new Date(date)
  if (isNaN(d)) return ''
  return d.toLocaleString('en-GB', { month: 'long', year: 'numeric' })
}

export function todayISO() {
  return new Date().toISOString().split('T')[0]
}

export function getCalendarDays(year, month) {
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)

  let startDow = firstDay.getDay() - 1
  if (startDow < 0) startDow = 6

  const days = []

  for (let i = 0; i < startDow; i++) {
    const d = new Date(year, month, -startDow + i + 1)
    days.push({ date: d, isCurrentMonth: false })
  }

  for (let i = 1; i <= lastDay.getDate(); i++) {
    days.push({ date: new Date(year, month, i), isCurrentMonth: true })
  }

  const remaining = 7 - (days.length % 7)
  if (remaining < 7) {
    for (let i = 1; i <= remaining; i++) {
      days.push({ date: new Date(year, month + 1, i), isCurrentMonth: false })
    }
  }

  return days
}

export const CALENDAR_DAY_HEADERS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export function parseDateEU(str) {
  if (!str) return null
  const parts = str.split('/')
  if (parts.length !== 3) return null
  const [day, month, year] = parts.map(Number)
  const d = new Date(year, month - 1, day)
  return isNaN(d) ? null : d
}
